import { useParams } from 'react-router-dom';
import { all } from '../data/all';
import NotFound from './NotFound';

function Country() {
    const { country } = useParams();
    
    let countryData = [];

    all.forEach(thisCountry => {
        if (thisCountry.name.common === country) {
            countryData = JSON.stringify(thisCountry);
        }
    })

    if (countryData.length === 0) {
        return (
            <NotFound />
        )
    } else {
        return (
            <code>
                { countryData }
            </code>
        )
    }
}

export default Country;